import React, { Component }          from 'react';

import axios                         from 'axios';
import { IndeterminateProgress }     from '../common/IndeterminateProgress';
import warholLogo                    from '../../img/warhol-logo.svg';
import whiteWarholLogo               from '../../img/static-frontpage-components/the-warhol_all-white.png';
import screenTestMachineLogo         from '../../img/static-frontpage-components/screen-test-machine_logo.png';
import theAWML                       from '../../img/static-frontpage-components/TAWM-full-logo--white.png';
import icPlay                        from '../../img/ic_play.png';

import "./Download.scss";

class Login extends Component {

  constructor(props) {
    super(props);

    this.state            = {
      isSubmitting: false,
      url: '',
      playing: false,
      infoLink: "",
      infoLinkText: "",
      downloadUrl: "",
      // imageUrl: warholLogo
    }

    this.videoRef = React.createRef();
  }

  componentDidMount() {
    this.getSignedUrl();
  }

  getSignedUrl() {
    const downloadIndex = window.location.hash.indexOf("/download?");
    const urlParams1 = new URLSearchParams(window.location.hash.slice(downloadIndex + 9, window.location.hash.length))
    const key = urlParams1.get('key');
    if (key) {
      this.setState({url: '/static-frontpage/components/screentest-test.mp4', urlKey: key});

      axios.get(`/api/main-image-by-recording-url/${key}`).then(response => {
        if (response && response.data) {
          const imageUrl = response.data.imageUrl || warholLogo;
          const contactEmail = response.data.contactEmail ? `mailto:${response.data.contactEmail}` : "https://www.warhol.org/contact/";
          this.setState({contactEmail, url: '/static-frontpage/components/screentest-test.mp4', imageUrl: imageUrl, infoLink: response.data.infoLink, infoLinkText: response.data.infoLinkText, downloadUrl: `/api/download-video?key=${key}`})
        } else {
          this.setState({contactEmail, imageUrl: warholLogo, downloadUrl: `/api/download-video?key=${key}`})
        }
      })
    } else {
      this.setState({url: null});
    }
  }

  renderVideo() {
    if (this.state.url !== null) {
      return <div className="downloadable-video-container">
          <div className="video-container">
            <video poster={`/api/poster?key=${this.state.urlKey}`} type="video/mp4" id="downloadable-video"  width={"100%"} height={"100%"} preload='none' className="mobile" controls={true} autoPlay={false} playsInline={true} muted={true}>
              <source src={`/api/stream?key=${this.state.urlKey}`} type="video/mp4"></source>
            </video>
            <video poster={`/api/poster?key=${this.state.urlKey}`} className="desktop" ref={this.videoRef} controls={true} src={`/api/stream?key=${this.state.urlKey}`} playsInline muted={true} loop={true}/>
          </div>
        </div>
      // return <video ref={this.videoRef} controls={true} src={this.state.url} muted="true" loop="true"/>
    } else {
      return <div className="not-available">
        <div className="text">VIDEO NOT AVAILABLE</div>
      </div>
    }
  }

  render() {
    return (
      <div className={`download__container`}>
        <div className="scrollable">
          <div className="top-logo">
            <img src={this.state.imageUrl} />
          </div>
          <div className="screen-test-logo">
            <img src={screenTestMachineLogo} />
          </div>
          <div className={`download-content ${this.state.isSubmitting ? 'blur' : ''}`}>
            {this.renderVideo()}
            <div className="button-container">
              <a href={this.state.downloadUrl} download="screentest.mp4"><div className="action-button">Download and Share</div></a>
            </div>
            <div className="text-container">
              <img src={theAWML} />
              <div className="text">The Screen Test Machine is an interactive experience developed by The Andy Warhol Museum.</div>
              <div className="text">The Screen Test Machine is available to rent as part of our Exhibition Rental service or it can be added to a Museum Rental, inquire at <a target="_blank" href="https://www.warhol.org/contact">warhol.org/contact</a>.</div>
              <div className="divider"></div>
              <div class="footer">
                <div class="content">
                  <span class="thq-body-small">© <span id="year"></span> The Andy Warhol Museum</span>
                </div>
                <div class="links">
                  <a href="https://www.warhol.org/legal-notice/" target="_blank" rel="noreferrer noopener" class="thq-body-small">
                    Legal Notice
                  </a>
                  <a href="https://carnegiemuseums.org/privacy-policy/" target="_blank" rel="noreferrer noopener" class="thq-body-small">
                    Privacy Policy
                  </a>
                  <a href={this.state.contactEmail} target="_blank" rel="noreferrer noopener" class="thq-body-small">
                    Support
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Login;